// extracted by mini-css-extract-plugin
module.exports = {"link":"_23a2Kr2teCOI"};